import { useCallback, useMemo, useState } from 'react';

export const useImageLoading = (images: string[]) => {
    const [failedImages, setFailedImages] = useState<Set<number>>(new Set());

    const handleImageLoadError = useCallback((index: number) => {
        setFailedImages((prev) => new Set(prev).add(index));
    }, []);

    const displayableImages = useMemo(
        () => images.map((image, index) => ({ image, originalIndex: index })).filter((item) => !failedImages.has(item.originalIndex)),
        [images, failedImages],
    );

    return {
        displayableImages,
        handleImageLoadError,
    };
};
